import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

/**
 * Histórico del colaborador (Fase 2.5): agrupa los dos listados de solo
 * lectura consumidos por HistoryTabComponent (pills "Trayectoria" y
 * "Vacaciones y faltas"). No existen endpoints de creación para estos datos.
 */
@Injectable({
    providedIn: 'root'
})
export class HistoryService {

    constructor(private api: ApiService) { }

    listCareerHistory(employeeId: number | string): Observable<any> {
        return this.api.get(`hr/employee/${employeeId}/career-history/list`);
    }

    listLeaveHistory(employeeId: number | string): Observable<any> {
        return this.api.get(`hr/employee/${employeeId}/leave-history/list`);
    }
}
